import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@/components/ThemeProvider";
import Input from "antd/lib/input";

import "./IndexerTargetTable.less";

function IndexerTargetTable({ targetTable, onChange, viewMode, disabled }) {
  const { isDarkMode } = useTheme();
  
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div className={`indexer-target-table ${isDarkMode ? 'dark-mode' : ''}`}>
      {viewMode ? (
        <div className="table-display">
          {targetTable || "Not specified"}
        </div>
      ) : (
        <Input
          className="table-input"
          value={targetTable || ''}
          onChange={handleChange}
          disabled={disabled}
          placeholder="Enter target table name"
        />
      )}
    </div>
  );
}

IndexerTargetTable.propTypes = {
  targetTable: PropTypes.string,
  onChange: PropTypes.func,
  viewMode: PropTypes.bool,
  disabled: PropTypes.bool
};

IndexerTargetTable.defaultProps = {
  targetTable: '',
  onChange: null,
  viewMode: false,
  disabled: false
};

export default IndexerTargetTable; 